// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Coordinate } from './Coordinate';
import { FlightPlan } from './FlightPlan';
import { PathPoint } from './PathPoint';
import { PathPointLoadClassification } from './PathPointLoadClassification';
import { Flight } from './Flight';

export class Aerodrome implements IAerodrome {
    id!: string;
    name!: string;
    location!: Coordinate;

    constructor(data?: IAerodrome) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.location = _data["location"] ? Coordinate.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Aerodrome {
        data = typeof data === 'object' ? data : {};
        let result = new Aerodrome();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAerodrome {
    id: string;
    name: string;
    location: Coordinate;
}